import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { ellipsisMultiline } from '@/styles/helpers';

export const Box = styled.div`
  padding: 15px;
  display: flex;
  align-items: center;
  gap: 5px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.primary.border};
  background-color: ${({ theme }) => theme.palette.secondary.background};
`;

export const Title = styled(Typography.Title)`
  margin-bottom: 5px;
`;

export const Text = styled(Typography.Body)`
  ${ellipsisMultiline(1)}
`;

export const Paragraph = styled(Typography.Title).attrs({ $variant: '3' })`
  text-align: center;
  color: ${({ theme }) => theme.palette.secondary.labels};
`;
